export default "__VITE_ASSET__3129b6f7__"